import type { MbcBriefAssetTarget, MbcBriefQuality } from "@nlc/shared-types";

import { BriefQualityCard } from "@/features/request/mbc-review/components/BriefQualityCard";

import type { BriefMemory } from "../hooks/useBriefMemory";

import { UploadedFilesPanel } from "./UploadedFilesPanel";

type BriefSidebarProps = {
  /** Files need a request to hang on, which exists only once the chat starts. */
  canAddFiles: boolean;
  isCalculating: boolean;
  memory: BriefMemory | null;
  onAddAssets: () => void;
  onFilesChanged: (target: MbcBriefAssetTarget) => void;
  quality: MbcBriefQuality | null;
};

export function BriefSidebar({
  canAddFiles,
  isCalculating,
  memory,
  onAddAssets,
  onFilesChanged,
  quality,
}: BriefSidebarProps) {
  return (
    <div className="hidden min-h-0 w-full max-w-[320px] shrink-0 flex-col gap-xl lg:flex">
      <BriefQualityCard
        className="max-h-[58%] shrink-0 border-border-secondary shadow-none"
        isCalculating={isCalculating}
        quality={quality}
      />

      <UploadedFilesPanel
        canAddFiles={canAddFiles}
        memory={memory}
        onAddAssets={onAddAssets}
        onFilesChanged={onFilesChanged}
      />
    </div>
  );
}
